import { render, staticRenderFns } from "./admin-areas.vue?vue&type=template&id=7e7b7c58&scoped=true"
import script from "./admin-areas.vue?vue&type=script&lang=js"
export * from "./admin-areas.vue?vue&type=script&lang=js"
import style0 from "./admin-areas.vue?vue&type=style&index=0&id=7e7b7c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7b7c58",
  null
  
)

export default component.exports